import React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import Dropzone from 'react-dropzone'
import { Button, Icon, Popup } from 'semantic-ui-react'

import { toastClear, toastError } from 'ducks/app'
import { DropzoneContainer } from './styled'
import { calculateFileSize } from 'core/utilities'
import r from 'reactotron-react-js'
import { getTextResult, textKey } from 'core/textResult'

const FileInput = (props) => {
  const {
    label,
    label2,
    oldFiles = [],
    change,
    onRemoveOldFile,
    require,
    input,
    duplicateCheck,
    style,
    limitFileSize = 30, //mb
    limitFileItem = -1,
    multipleSelect = false,
    disabled = false,
    // acceptFileType = ['.jpeg','.jpg',.png,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx'],
    acceptFileType = {
      'application/pdf': [],
      'image/jpeg': [],
      'image/png': [],
      'application/msword': [],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
      'application/vnd.ms-excel': [],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
    },
    meta: { touched, error }
  } = props

  const findLastIndex = () => {
    let count = oldFiles.length
    let index = -1;
    for (let i = (count - 1); i >= 0; i--) {
      let temp = oldFiles[i]
      r.log(temp)
      if (!temp.deleted && temp.attachment_type_code.toLowerCase() == input.name.toLowerCase()) {
        index = i
        break;
      }
    }
    return index
  }
  const isHasAttachment = (attachment_type_code) => {
    let index = oldFiles.findIndex(x => x.attachment_type_code === attachment_type_code)
    return index >= 0
  }

  return (
    <div className='w-1/2 px-3' style={{ ...style }}>
      <div className="flex w-full flex-col">
        <div className="text-left whitespace-nowrap">
          {label}

          {require ? <span className='ml-2 text-red-500 require'>*</span> : null}
          {touched && error ? <span className='error ml-2 text-red-500'>{error}</span> : null}

        </div>
        <div className={`text-left whitespace-nowrap ${label2 ? "mt-2" :""}`} >
          {label2}
        </div>
      </div>
      <div className='border-slate-300'>
        {!disabled ?
          <Dropzone
            name={input.fileName}
            accept={acceptFileType}
            multiple={multipleSelect}
            onDrop={acceptedFiles => {
              // const checkCaseLimitFileItem = (currentInput, file) => {
              //   if (oldFiles) {//case has old file
              //     let countOldFile = oldFiles.filter(x => !x.deleted && x.attachment_type_code.toLowerCase() == input.name.toLowerCase()).length
              //     if (countOldFile == limitFileItem) {//case no new file but old file equre limitFileItem
              //       //get last index to delete file
              //       let lastIndex = findLastIndex()
              //       change(`attachments[${lastIndex}].deleted`, true)
              //       input.onChange([...currentInput, file])
              //     } else if ((currentInput.length + countOldFile) == limitFileItem) {//case newFile + oldFile equre limitfileItem
              //       currentInput.splice((currentInput.length - 1), 1)
              //       input.onChange([...currentInput, file])
              //     } else {
              //       input.onChange([...currentInput, file])
              //     }
              //   } else {//case no old file
              //     if (currentInput.length < limitFileItem) {
              //       input.onChange([...currentInput, file])
              //     } else {
              //       //replace last file
              //       currentInput.splice((currentInput.length - 1), 1)
              //       input.onChange([...currentInput, file])
              //     }
              //   }
              // }
              const checkCaseLimitFileItem = (currentInput, file) => {
                if (oldFiles) {//case has old file
                  let countOldFile = oldFiles.filter(x => !x.deleted && x.attachment_type_code.toLowerCase() == input.name.toLowerCase()).length
                  if (countOldFile == limitFileItem) {//case no new file but old file equre limitFileItem
                    props.toastError(`You can only upload a maximum of ${limitFileItem} files`)
                  } else if ((currentInput.length + countOldFile) == limitFileItem) {//case newFile + oldFile equre limitfileItem
                    props.toastError(`You can only upload a maximum of ${limitFileItem} files`)
                  } else {
                    input.onChange([...currentInput, file])
                  }
                } else {//case no old file
                  if (currentInput.length < limitFileItem) {
                    input.onChange([...currentInput, file])
                  } else {
                    props.toastError(`You can only upload a maximum of ${limitFileItem} files`)
                  }
                }
              }
              acceptedFiles.forEach(file => {
                const reader = new FileReader()
                let currentInput = input.value || []
                reader.onload = () => {
                  if ((file.size / (1024 * 1024)).toFixed(2) > limitFileSize) { //filter file size
                    props.toastError(getTextResult(textKey.TEXTERROR5))
                    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top
                  } else if (duplicateCheck) { //case alert duplicate file
                    let newFileDup = -1
                    if (currentInput) {
                      // get duplicate new file
                      newFileDup = currentInput.findIndex(x => x.path === file.path)
                    }
                    // get duplicate old file                
                    let oldFileDup = oldFiles ? oldFiles.findIndex(x => x.originalFilename === file.path && !x.deleted && x.attachment_type_code.toLowerCase() == input.name.toLowerCase()) : -1
                    if (oldFileDup < 0 && newFileDup < 0) {// no duplicate file
                      input.onChange([...currentInput, file])
                    } else {
                      props.toastError('There is already a file with the same name')
                    }
                  } else if (limitFileItem > 0) {//case limit file item
                    checkCaseLimitFileItem(currentInput, file)
                  } else {
                    input.onChange([...currentInput, file])
                    props.toastClear()
                  }
                }
                reader.onabort = () => console.log('file reading was aborted')
                reader.onerror = () => console.log('file reading has failed')

                reader.readAsBinaryString(file)
              })
            }}
          >
            {({ getRootProps, getInputProps, isDragActive }) => {
              return (
                <DropzoneContainer
                  {...getRootProps()}
                  className={classnames('dropzone', { 'dropzone--isActive': isDragActive })}
                >
                  <div className='inputContent  '>
                    <input name={input.name} {...getInputProps()} />
                    <div className={classnames('dropArea', { error: touched && error })}>
                      <div className=' text-base lg:text-xl '><Icon name='upload' />  Drag file to upload</div>
                      <div className='text-base lg:text-xl'>Or</div>
                      <div className='text-base lg:text-xl flex justify-center rounded-lg bg-neutral-300 text-center shadow-sm shadow-black/30 '>
                        <div className='mx-5'>Choose File</div>
                      </div>
                    </div>
                  </div>
                </DropzoneContainer>
              )
            }}
          </Dropzone> : null}
        {//render new file
          input?.value instanceof Array ?
            input.value.map((file, index) => {
              return (
                <div key={index} className='pt-2 flex '>
                  <div className="flex divide-x p-2 items-center rounded-lg bg-slate-50 text-center shadow-sm shadow-black/30">
                    <div className='w-full px-2 flex justify-between'>
                      <div className='w-full text-left word-wrap'>{file.name}</div> {/* ตรงนี้เพิ่ม className 'word-wrap' */}
                      <div className=''>{calculateFileSize(file.size)}</div>
                    </div>
                    <div className='pl-2'>
                      <Icon
                        link
                        name='trash alternate'
                        color='red'
                        onClick={() => {
                          var clone = [...input.value]
                          clone.splice(index, 1)
                          input.onChange([...clone])
                        }}
                      />
                    </div>
                  </div>
                </div>
              )
            }) : null
        }
        {//render old file
          isHasAttachment(input.name) ?
            oldFiles.map((file, index) => {
              if (file.deleted || file.attachment_type_code != input.name) return null
              return (
                <div key={index} className='pt-2  flex '>
                  <div className="flex divide-x p-2 items-center rounded-lg bg-slate-50 text-center shadow-sm shadow-black/30 ">
                    <div className='w-full px-2 flex justify-between'>
                      <div className='w-full text-left cursor-pointer' onClick={() => { file.url_path && window.open(file.url_path) }}>{file.original_file_name}</div>
                      <div className='whitespace-nowrap'>{calculateFileSize(file.file_size)}</div>
                    </div>
                    <div className='pl-2'>
                      {!disabled ?
                        <Icon
                          link name='trash alternate'
                          color='red'
                          onClick={() => { if (onRemoveOldFile) onRemoveOldFile(index) }}
                        /> : null}
                    </div>
                  </div>
                </div>
              )
            }) : null
        }
        {
          disabled && !isHasAttachment(input.name) ?
            <div className='text-left'>There is no file</div>
            : null
        }
      </div>
    </div>
  )
}
const mapStateToProps = (state) => ({})
const mapDispatchToProps = {
  toastError,
  toastClear
}

export default connect(mapStateToProps, mapDispatchToProps)(FileInput)  